module.exports = __webpack_public_path__ + "img/vip.156410fd.png";